export default __webpack_public_path__ + "static/media/img-kia-logo.f276e23c.svg";